import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import React, { useEffect, useState } from "react";
import { observer, Observer } from "mobx-react";
import GlobalStyles from "../../../Resources/Styles";
import Colors from "../../../Resources/Color";
import Fonts from "../../../Resources/Fonts";
import { Ionicons } from "@expo/vector-icons";
import { Entypo } from "@expo/vector-icons";
import { FontAwesome5 } from "@expo/vector-icons";
import { Menu, MenuItem } from "react-native-material-menu";
import IconEmptyView from "../../Components/IconEmptyView";
import { useTranslation } from "react-i18next";
import SyncStatusIndicator from "../../Components/SyncStatusIndicator";
import AddCompetitionView from "./AddCompetitionView";

import CustomAlert from "../../Components/CustomAlert";

import { format } from "date-fns";

import { useScreenDimensions, useDevice } from "../../_layout";
import LogoImage from "../../Components/LogoImage";
import CustomActivityIndicator from "../../Components/CustomActivityIndicator";
import CTAButton from "../../Components/CTAButton";
import SearchBar from "../../Components/SearchBar";
import ClientGameDay from "./ClientGameDay";
import TutorialLinkSection from "../../Components/TutorialLinkSection";
import { getWeightClasses } from "./competitionFederationConfig";

const CoachCompetitions = ({ coach }) => {
  const { t } = useTranslation();
  const { screenSize } = useScreenDimensions();
  const [showingAddNewCompetition, setShowingAddNewCompetition] =
    useState(false);

  const { isMobile } = useDevice();

  const [showingEditCompetition, setShowingEditCompetition] = useState(false);

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      await coach.syncStatusManager.safeOperation("fetchPastCompetitions", () =>
        coach.fetchCompetitionsFromCloud(false)
      );
      setLoading(false);
    })();
  }, []);

  const CompetitionRow = observer(({ competition }) => {
    const [showingDeleteAlert, setShowingDeleteAlert] = useState(false);
    const deleteAlertTitle = "deleteCompetitionAlertTitle-string";
    const deleteAlertText = "deleteCompetitionAlertText-string";

    const [competitionMenu, setCompetitionMenu] = useState(false);
    const showCompetitionMenu = () => setCompetitionMenu(true);

    const action = () => {
      competition.setProperty("isShown", !competition.isShown);
    };

    const showDeleteAlert = () => {
      setShowingDeleteAlert(true);
      setCompetitionMenu(false);
    };
    const showEditCompetition = () => {
      coach.setSelectedCompetition(competition);
      setShowingEditCompetition(true);
      setCompetitionMenu(false);
    };

    const ClientRow = observer(({ client }) => {
      const action = () => {
        coach.setSelectedClientComp(client);
        coach.selectedClientComp.setSelectedCompetition(competition);
        // console.log("CLIENT COMPS: ", client.competitions);
      };

      const [isHovered, setIsHovered] = useState(false);

      return (
        <View
          style={{
            width: `calc((100% - ${screenSize === "small" ? 8 : 24}px) / ${
              screenSize === "small" ? 2 : 3
            })`,
          }}
        >
          <TouchableOpacity
            onPress={action}
            style={[
              GlobalStyles.touchableRow,
              {
                shadowColor: Colors.bubbleColor,
                borderWidth: 0.1,
                borderColor: isHovered
                  ? "rgba(0, 0, 0, 0.5)"
                  : Colors.borderColor,
                marginBottom: 0,
              },
            ]}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <View style={{ alignItems: "flex-start", flex: 1 }}>
              <Text
                numberOfLines={2}
                style={[Fonts.medium13, { flexShrink: 1, marginBottom: 8 }]}
              >
                {client.nameForCoach} {client.surnameForCoach}
              </Text>
              <Text
                numberOfLines={1}
                style={[
                  Fonts.medium10,
                  { color: Colors.grayColor, flexShrink: 1 },
                ]}
              >
                {client.getBlockCurrentName != null
                  ? client.getBlockCurrentName
                  : t("withoutActiveBlock-string")}
              </Text>
            </View>
          </TouchableOpacity>
        </View>
      );
    });

    const femaleWeightClasses = getWeightClasses(competition.competitionLevel, true);
    const maleWeightClasses = getWeightClasses(competition.competitionLevel, false);

    const CategoryRow = observer(({ category, gender }) => {
      return (
        coach.clientsInWeightClass(competition, category, gender).length > 0 && (
          <View style={{ width: "100%" }}>
            <View>
              <Text
                style={[Fonts.regular12, { marginVertical: 8, marginLeft: 4 }]}
              >
                {category}
              </Text>
            </View>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "flex-start",
                flexWrap: "wrap",
                gap: screenSize === "small" ? 8 : 12,
              }}
            >
              {coach
                .clientsInWeightClass(competition, category, gender)
                .map((client) => {
                  return <ClientRow client={client} key={client.id} />;
                })}
            </View>
          </View>
        )
      );
    });

    const [isHovered, setIsHovered] = useState(false);

    const [isMenuHovered, setIsMenuHovered] = useState(false);

    const MenuItemView = ({ idx }) => {
      const [isHovered, setIsHovered] = useState(false);

      return idx === 1 ? (
        <MenuItem
          onPress={showEditCompetition}
          style={{ minWidth: 150 }}
          textStyle={{ fontSize: 14, fontWeight: isHovered ? "600" : "normal" }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {t("edit-string")}
        </MenuItem>
      ) : (
        <MenuItem
          onPress={showDeleteAlert}
          style={{ minWidth: 150 }}
          textStyle={{
            fontSize: 14,
            color: "red",
            fontWeight: isHovered ? "600" : "normal",
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {t("delete-string")}
        </MenuItem>
      );
    };

    return (
      <View style={{ width: "100%" }}>
        <TouchableOpacity
          onPress={action}
          style={[
            styles.row,
            {
              paddingTop: screenSize === "small" ? 12 : 15,
              paddingBottom: screenSize === "small" ? 12 : 15,
              paddingHorizontal: screenSize === "small" ? 12 : 15,
              marginBottom: screenSize === "small" ? 8 : 12,
              borderColor:
                isHovered && !competition.isShown
                  ? "rgba(0, 0, 0, 0.5)"
                  : Colors.borderColor,
            },
          ]}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={{
              flexDirection: "row",
              width: "100%",
              height: screenSize !== "small" && 65,
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <View
              style={{
                flexShrink: 1,
              }}
            >
              <Text
                numberOfLines={2}
                style={[
                  screenSize === "small" ? Fonts.medium14 : Fonts.medium16,
                  { width: "100%", marginBottom: 10, flexShrink: 1 },
                ]}
              >
                {competition.name}
              </Text>
              <View
                style={[
                  GlobalStyles.HStack,
                  { width: "100%", flexWrap: "wrap" },
                ]}
              >
                <View style={[GlobalStyles.HStack]}>
                  <Ionicons
                    name="calendar"
                    size={screenSize === "small" ? 12 : 14}
                    color={Colors.bubbleColor}
                    style={GlobalStyles.rowIcon}
                  />
                  <Text
                    style={{
                      ...GlobalStyles.rowSubText,
                      fontSize: screenSize === "small" ? 12 : 14,
                    }}
                  >
                    {competition.date < new Date()
                      ? `${format(competition.date, "dd/MM/yyyy")}`
                      : `${format(
                          competition.date,
                          "dd/MM/yyyy"
                        )} - ${competition.weeksOut(t)}`}
                  </Text>
                </View>
                <View style={[GlobalStyles.HStack]}>
                  <FontAwesome5
                    name="clipboard-list"
                    size={screenSize === "small" ? 12 : 14}
                    color={Colors.bubbleColor}
                    style={GlobalStyles.rowIcon}
                  />
                  <Text
                    style={{
                      ...GlobalStyles.rowSubText,
                      fontSize: screenSize === "small" ? 12 : 14,
                    }}
                  >
                    {competition.competitionClass}
                  </Text>
                </View>

                <View style={[GlobalStyles.HStack]}>
                  <Ionicons
                    name="podium"
                    size={screenSize === "small" ? 12 : 14}
                    color={Colors.bubbleColor}
                    style={GlobalStyles.rowIcon}
                  />
                  <Text
                    style={{
                      ...GlobalStyles.rowSubText,
                      fontSize: screenSize === "small" ? 12 : 14,
                    }}
                  >
                    {competition.competitionLevel}
                  </Text>
                </View>

                <View style={[GlobalStyles.HStack]}>
                  <Ionicons
                    name="person"
                    size={screenSize === "small" ? 12 : 14}
                    color={Colors.bubbleColor}
                    style={GlobalStyles.rowIcon}
                  />
                  <Text
                    style={{
                      ...GlobalStyles.rowSubText,
                      fontSize: screenSize === "small" ? 12 : 14,
                    }}
                    numberOfLines={1}
                  >
                    {coach.clientsInComp(competition).length === 1
                      ? t("athleteCountOne-string", {
                          count: coach.clientsInComp(competition).length,
                        })
                      : t("athleteCount-string", {
                          count: coach.clientsInComp(competition).length,
                        })}
                  </Text>
                </View>

                <View style={[GlobalStyles.HStack]}>
                  <Ionicons
                    name="checkmark-circle"
                    size={screenSize === "small" ? 12 : 14}
                    color={Colors.bubbleColor}
                    style={{ ...GlobalStyles.rowIcon, marginTop: 4 }}
                  />
                  <Text
                    style={{
                      ...GlobalStyles.rowSubText,
                      fontSize: screenSize === "small" ? 12 : 14,
                    }}
                    numberOfLines={1}
                  >
                    {competition.totalValidAttempts(t)}
                  </Text>
                </View>
                <View style={GlobalStyles.HStack}>
                  <Ionicons
                    name="checkmark-circle-outline"
                    size={screenSize === "small" ? 12 : 14}
                    color={Colors.bubbleColor}
                    style={{ ...GlobalStyles.rowIcon, marginTop: 4 }}
                  />
                  <Text
                    style={{
                      ...GlobalStyles.rowSubText,
                      fontSize: screenSize === "small" ? 12 : 14,
                      marginRight: 0,
                    }}
                    numberOfLines={1}
                  >
                    {competition.totalValidThirdAttempts(t)}
                  </Text>
                </View>
              </View>
            </View>

            <Menu
              visible={competitionMenu}
              anchor={
                <TouchableOpacity
                  onPress={showCompetitionMenu}
                  onMouseEnter={() => !isMobile && setIsMenuHovered(true)}
                  onMouseLeave={() => setIsMenuHovered(false)}
                >
                  <Entypo
                    name="dots-three-horizontal"
                    size={screenSize === "small" ? 22 : 24}
                    color="black"
                    style={{
                      paddingVertical: screenSize === "small" ? 8 : 16,
                      paddingHorizontal: screenSize === "small" ? 0 : 16,
                      opacity: isMenuHovered ? 0.5 : 1,
                      marginLeft: screenSize === "small" ? 8 : 0,
                    }}
                  />
                </TouchableOpacity>
              }
              style={GlobalStyles.menu}
              onRequestClose={() => setCompetitionMenu(false)}
            >
              <MenuItemView idx={1} />
              <MenuItemView idx={2} />
            </Menu>
          </View>

          {competition.isShown && (
            <>
              <View
                style={{
                  marginTop: 8,
                  height: 3,
                  borderColor: Colors.borderColor,
                  width: "100%",
                  borderTopWidth: 0.1,
                }}
              />
              {coach.clientsInGender(competition, true).length > 0 && (
                <>
                  <Text
                    style={[Fonts.medium12, { width: "100%", marginTop: 16 }]}
                  >
                    {t("women-string")}
                  </Text>
                  {femaleWeightClasses.map((weightClass) => (
                    <CategoryRow
                      key={weightClass}
                      category={weightClass}
                      gender={true}
                    />
                  ))}
                </>
              )}
              {coach.clientsInGender(competition, false).length > 0 && (
                <>
                  <Text
                    style={[Fonts.medium12, { width: "100%", marginTop: 16 }]}
                  >
                    {t("men-string")}
                  </Text>
                  {maleWeightClasses.map((weightClass) => (
                    <CategoryRow
                      key={weightClass}
                      category={weightClass}
                      gender={false}
                    />
                  ))}
                </>
              )}
              {coach.clientsInGender(competition, true).length === 0 &&
                coach.clientsInGender(competition, false).length === 0 && (
                  <IconEmptyView
                    iconLibrary="Ionicons"
                    mainText="emptyClientsTitle-string"
                    subText="noAthletesInCompetitionText-string"
                    iconName="people-outline"
                    marginTop={56}
                    marginBottom={16}
                  />
                )}
            </>
          )}
        </TouchableOpacity>

        {showingDeleteAlert && (
          <CustomAlert
            isVisible={showingDeleteAlert}
            onClose={() => setShowingDeleteAlert(false)}
            title={deleteAlertTitle}
            text={deleteAlertText}
            action={() => coach.deleteCompetition(competition)}
            specialCTA={"delete-string"}
          />
        )}
      </View>
    );
  });

  const showAddNewComp = () => {
    setShowingAddNewCompetition(true);
  };

  return (
    <View style={styles.container}>
      <View>
        <View
          style={[
            GlobalStyles.HStack,
            {
              width: "100%",
              marginBottom: screenSize === "small" ? 20 : 20,
              alignItems: "center",
            },
          ]}
        >
          <Text
            style={[
              Fonts.bold24,
              { marginRight: screenSize === "small" ? 8 : 12, fontWeight: "600" },
            ]}
          >
            {t("competitions-string")}
          </Text>

          <Observer>
            {() => (
              <>
                {!coach.selectedClientComp && (
                  <SyncStatusIndicator
                    syncStatusManager={coach.syncStatusManager}
                    onPress={() => coach.startOrResetBatchTimer()}
                  />
                )}
              </>
            )}
          </Observer>
          <View style={{ flex: 1 }} />
          <LogoImage coach={coach} />
        </View>

        <Observer>
          {() => (
            <>
              {coach.selectedClientComp &&
              coach.selectedClientComp.selectedCompetition ? (
                <ClientGameDay
                  competition={coach.selectedClientComp.selectedCompetition}
                  client={coach.selectedClientComp}
                />
              ) : (
                <>
                  <View style={GlobalStyles.HStack}>
                    <View style={{ maxWidth: "45%" }}>
                      <SearchBar
                        text={coach.searchTermCompetitions}
                        onChangeText={(text) =>
                          coach.setProperty("searchTermCompetitions", text)
                        }
                        placeholder={t("searchCompetition-string")}
                        autoFocusOnDesktop={true}
                      />
                    </View>

                    <CTAButton
                      plus={true}
                      text={t("newCompetition-string")}
                      action={() => showAddNewComp(true)}
                      disabled={false}
                    />
                  </View>
                  {coach.isOffline && (
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 4,
                        marginTop: 16,
                      }}
                    >
                      <Ionicons
                        name="alert-circle-outline"
                        size={20}
                        color={Colors.grayColor}
                      />
                      <Text style={{ color: Colors.grayColor }}>
                        {t("offlineCompetitionsInformationMissing-string")}
                      </Text>
                    </View>
                  )}
                  {coach.showCompetitionInfoView && (
                    <TutorialLinkSection
                      text="tutorialCompetitionGameplan-string"
                      urlPath="/competitions"
                      marginTop={24}
                      marginBottom={0}
                    />
                  )}

                  {!loading ? (
                    <>
                      {coach.getFilteredCompetitions().length === 0 ? (
                        <IconEmptyView
                          iconLibrary={"Ionicons"}
                          mainText={"emptyCompetitionsLibraryTitle-string"}
                          subText={"emptyCompetitionsLibraryText-string"}
                          iconName={"podium-outline"}
                          marginTop={130}
                        />
                      ) : (
                        <View
                          style={{
                            justifyContent: "flex-start",
                            marginTop: screenSize === "small" ? 8 : 12,
                          }}
                        >
                          {coach
                            .getFilteredCompetitions()
                            .map((competition) => {
                              return (
                                <CompetitionRow
                                  competition={competition}
                                  key={competition.id}
                                />
                              );
                            })}
                        </View>
                      )}
                    </>
                  ) : (
                    <CustomActivityIndicator marginTop={130} />
                  )}
                </>
              )}
            </>
          )}
        </Observer>
        {showingAddNewCompetition && (
          <AddCompetitionView
            isVisible={showingAddNewCompetition}
            onClose={() => setShowingAddNewCompetition(false)}
            coach={coach}
          />
        )}
        {showingEditCompetition && coach.selectedCompetition && (
          <AddCompetitionView
            isVisible={showingEditCompetition}
            onClose={() => setShowingEditCompetition(false)}
            coach={coach}
            competition={coach.selectedCompetition}
          />
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.backgroundColor,
  },
  row: {
    backgroundColor: "white",
    borderRadius: 14,
    borderWidth: 0.1,
    justifyContent: "space-between",
    alignItems: "center",
  },
});

export default CoachCompetitions;
